import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "filterList", "panel"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
    document.addEventListener("keydown", this.boundHandleKeydown)
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.hasMenuTarget) {
      const isHidden = this.menuTarget.classList.contains("hidden")
      if (isHidden) {
        this.openMenu()
      } else {
        this.closeMenu()
      }
    }
  }

  openMenu() {
    // Reset to filter list view
    this.showFilterList()
    this.menuTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    // Reset to filter list view for next open
    this.showFilterList()
  }

  showFilterList() {
    if (this.hasFilterListTarget) {
      this.filterListTarget.classList.remove("hidden")
    }
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })
  }

  showPanel(event) {
    event.stopPropagation()
    const panelType = event.currentTarget.dataset.panel

    // Hide filter list
    if (this.hasFilterListTarget) {
      this.filterListTarget.classList.add("hidden")
    }

    // Show the selected panel
    this.panelTargets.forEach(panel => {
      if (panel.dataset.panelType === panelType) {
        panel.classList.remove("hidden")
        // Focus input if present (use requestAnimationFrame for reliable timing after CSS transition)
        const input = panel.querySelector('input[type="text"], input[type="date"]')
        if (input) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              input.focus()
            })
          })
        }
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  hidePanel(event) {
    event.stopPropagation()
    this.showFilterList()
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && this.hasMenuTarget) {
      this.closeMenu()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      event.preventDefault()
      this.closeMenu()
      this.triggerTarget.focus()
    }
  }
}
